import {authAPI} from '../../services/AuthServices';
import {orderAPI} from '../../services/OrderServices';

export function useWorkshopDates(): string[] {
    const {currentData: auth, isFetching, error} = authAPI.useGetAuthContextQuery();
    const enabled = !isFetching && !error && auth?.isAuthenticated === true && auth.features?.includes('workshop') === true;
    const {currentData, isError} = orderAPI.useGetWorkshopDatesQuery(undefined, {
        skip: !enabled,
        refetchOnMountOrArgChange: true,
    });
    return enabled && !isError ? currentData ?? [] : [];
}
